import { ActionSheetProvider } from '@expo/react-native-action-sheet';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { CustomStatusBar } from 'app/components/app/custom-status-bar';
import { StripeProviderLPC } from 'app/components/app/stripe-provider-lpc';
import { queryPersistenceOptions } from 'app/lib/query-persistence';
import { queryClient } from 'app/lib/react-query';
import { AppThemeProvider } from './app-theme-provider';
import { getDefaultStore, Provider as JotaiProvider } from 'jotai';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { RootSiblingParent } from 'react-native-root-siblings';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { ClickOutsideProvider } from 'react-native-click-outside';

export function AppWithProviders({ children }: { children: React.ReactNode }) {
  return (
    <ClickOutsideProvider>
      <SafeAreaProvider>
        <AppThemeProvider>
          <GestureHandlerRootView style={{ flex: 1 }}>
            <ActionSheetProvider>
              <StripeProviderLPC>
                <PersistQueryClientProvider client={queryClient} persistOptions={queryPersistenceOptions}>
                  <JotaiProvider store={getDefaultStore()}>
                    <RootSiblingParent>
                      <CustomStatusBar />
                      {children}
                    </RootSiblingParent>
                  </JotaiProvider>
                </PersistQueryClientProvider>
              </StripeProviderLPC>
            </ActionSheetProvider>
          </GestureHandlerRootView>
        </AppThemeProvider>
      </SafeAreaProvider>
    </ClickOutsideProvider>
  );
}
